export default {
  SET_ITEMS(state, items) {
    state.items = items;
  },

  SET_PAGINATOR(state, { page, size, total }) {
    state.paginator.page = page;
    state.paginator.size = size;
    state.paginator.total = total;
  },

  SET_PAGINATOR_PAGE(state, value) {
    state.paginator.page = value;
  },

  SET_PAGINATOR_LOADING_PAGE(state, value) {
    state.paginator.loadingPage = value;
  },

  SET_SORT(state, { field, order }) {
    state.sort.field = field;
    state.sort.order = order;
  },

  SET_SORT_LOADING(state, value) {
    state.sort.loading = value;
  },

  SET_CURRENT(state, alert) {
    state.current = alert;
  },

  SET_LOADING(state, value) {
    state.isLoading = value;
  },

  SET_DQL_FIELDS(state, fields) {
    state.dqlFields = fields;
  },

  UPDATE_ITEM(state, updated) {
    const index = state.items.findIndex((item) => item.id === updated.id);
    if (index >= 0) {
      state.items.splice(index, 1, updated);
    }
  },

  BULK_UPDATE_STATUS(state, { ids, status }) {
    state.items = state.items.map((item) =>
      ids.includes(item.id) ? { ...item, status, inactive: true } : item,
    );
  },
};
